import React, { memo, SVGProps } from 'react'

export const Cross = memo((props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M6.2112 17.7888C6.35136 17.929 6.53568 18 6.72 18C6.90432 18 7.08864 17.9299 7.2288 17.7888L12 13.0176L16.7712 17.7888C16.9114 17.929 17.0957 18 17.28 18C17.4643 18 17.6486 17.9299 17.7888 17.7888C18.0701 17.5075 18.0701 17.0515 17.7888 16.7702L13.0176 11.999L17.7888 7.22784C18.0701 6.94656 18.0701 6.49056 17.7888 6.20928C17.5075 5.928 17.0515 5.928 16.7702 6.20928L11.999 10.9805L7.22784 6.20928C6.94656 5.928 6.49056 5.928 6.20928 6.20928C5.928 6.49056 5.928 6.94656 6.20928 7.22784L10.9805 11.999L6.20928 16.7702C5.928 17.0515 5.928 17.5075 6.20928 17.7888H6.2112Z"
      fill="currentColor"
    />
  </svg>
))
